import { render, staticRenderFns } from "./Withdraw.vue?vue&type=template&id=523b16bf&"
import script from "./Withdraw.vue?vue&type=script&lang=js&"
export * from "./Withdraw.vue?vue&type=script&lang=js&"
import style0 from "./Withdraw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports